﻿import { exact, number, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const approvalWorkflowHistoryType = exact({
  id: string.isRequired,
  workflowId: string.isRequired,
  workflowStepId: string.isRequired,
  currentStatus: number.isRequired,
  approverName: string,
  setBy: string.isRequired,
  setAt: string.isRequired,
});
